// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/publish_service.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * PublishStagingToProductionArgs メッセージ
 *
 * @generated from message service.PublishStagingToProductionArgs
 */
export class PublishStagingToProductionArgs extends Message<PublishStagingToProductionArgs> {
  constructor(data?: PartialMessage<PublishStagingToProductionArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.PublishStagingToProductionArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PublishStagingToProductionArgs {
    return new PublishStagingToProductionArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PublishStagingToProductionArgs {
    return new PublishStagingToProductionArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PublishStagingToProductionArgs {
    return new PublishStagingToProductionArgs().fromJsonString(jsonString, options);
  }

  static equals(a: PublishStagingToProductionArgs | PlainMessage<PublishStagingToProductionArgs> | undefined, b: PublishStagingToProductionArgs | PlainMessage<PublishStagingToProductionArgs> | undefined): boolean {
    return proto3.util.equals(PublishStagingToProductionArgs, a, b);
  }
}

/**
 * PublishStagingToProductionReply メッセージ
 *
 * @generated from message service.PublishStagingToProductionReply
 */
export class PublishStagingToProductionReply extends Message<PublishStagingToProductionReply> {
  /**
   * @generated from field: map<string, int32> published_counts = 1 [json_name = "published_counts"];
   */
  publishedCounts: { [key: string]: number } = {};

  /**
   * @generated from field: map<string, int32> deleted_counts = 2 [json_name = "deleted_counts"];
   */
  deletedCounts: { [key: string]: number } = {};

  constructor(data?: PartialMessage<PublishStagingToProductionReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.PublishStagingToProductionReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "published_counts", jsonName: "published_counts", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 2, name: "deleted_counts", jsonName: "deleted_counts", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PublishStagingToProductionReply {
    return new PublishStagingToProductionReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PublishStagingToProductionReply {
    return new PublishStagingToProductionReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PublishStagingToProductionReply {
    return new PublishStagingToProductionReply().fromJsonString(jsonString, options);
  }

  static equals(a: PublishStagingToProductionReply | PlainMessage<PublishStagingToProductionReply> | undefined, b: PublishStagingToProductionReply | PlainMessage<PublishStagingToProductionReply> | undefined): boolean {
    return proto3.util.equals(PublishStagingToProductionReply, a, b);
  }
}

